import { createContext } from 'react'

import UnitStore from 'common/stores/UnitStore'
import UploaderStore from 'common/stores/UploaderStore'

import { list } from 'vendor/server/public/units'
import DeliveryStore from 'vendor/stores/public/DeliveryStore'
import OrderStore from 'vendor/stores/public/OrderStore'

export interface StoresMapping {
  deliveryStore: DeliveryStore
  orderStore: OrderStore
  uploaderStore: UploaderStore
  unitsStore: UnitStore
}

export const storeInstances = {
  deliveryStore: new DeliveryStore(),
  orderStore: new OrderStore(),
  uploaderStore: new UploaderStore(),
  unitsStore: new UnitStore(list),
}

export const storesContext = createContext(storeInstances)
